import { useState, useEffect } from 'react';
import { NodeViewWrapper } from '@tiptap/react';
import type { NodeViewProps } from '@tiptap/react';
import { getVariablesMap } from './variableNode';
import { useQuoteDocumentMode } from '@/components/quote-document/QuoteDocument';

export default function VariableNodeView({ node, editor }: NodeViewProps) {
  const mode = useQuoteDocumentMode();
  const tag = (node.attrs.tag as string) || '';
  const label = (node.attrs.label as string) || tag;

  const [, forceUpdate] = useState(0);

  useEffect(() => {
    const handler = ({ transaction }: { transaction: { getMeta: (key: string) => unknown } }) => {
      if (transaction.getMeta('variablesMapUpdated')) {
        forceUpdate((n) => n + 1);
      }
    };
    editor.on('transaction', handler);
    return () => { editor.off('transaction', handler); };
  }, [editor]);

  const variablesMap = getVariablesMap(editor);
  const resolvedValue = variablesMap[tag] || variablesMap[`{{${tag}}}`] || '';
  const hasValue = resolvedValue.length > 0;

  if (hasValue) {
    return (
      <NodeViewWrapper as="span" className="variable-resolved" title={tag}>
        {resolvedValue}
      </NodeViewWrapper>
    );
  }

  // Klantweergave en PDF: geen editorchip (onleesbaar op gekleurde pagina's), wel de plaatshouder.
  if (mode === 'web' || mode === 'print') {
    return (
      <NodeViewWrapper as="span" className="variable-unresolved" title={tag}>
        {`{{${tag.replace(/^\{\{|\}\}$/g, '')}}}`}
      </NodeViewWrapper>
    );
  }

  return (
    <NodeViewWrapper
      as="span"
      className="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium cursor-default select-none align-baseline"
      style={{
        backgroundColor: 'rgba(0, 7, 236, 0.08)',
        color: 'rgb(0, 7, 236)',
        border: '1px solid rgba(0, 7, 236, 0.2)',
        lineHeight: '1.4',
        verticalAlign: 'baseline',
      }}
      title={tag}
    >
      {label}
    </NodeViewWrapper>
  );
}
